/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_DescriptionInputs */

const en_support_description = /** @type {(inputs: Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your sovereign contribution fuels our engine. It helps us decentralize commerce and build a censorship-resistant future for all creators.`)
};

const es_support_description = /** @type {(inputs: Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu contribución alimenta nuestro motor. Nos ayuda a descentralizar el comercio y construir un futuro resistente a la censura.`)
};

const fr_support_description = /** @type {(inputs: Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre contribution souveraine alimente notre moteur. Elle nous aide à décentraliser le commerce et à construire un avenir résistant à la censure pour tous les créateurs.`)
};

const de_support_description = /** @type {(inputs: Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein souveräner Beitrag treibt unseren Motor an. Er hilft uns, den Handel zu dezentralisieren und eine zensurresistente Zukunft aufzubauen.`)
};

const id_support_description = /** @type {(inputs: Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontribusi sovereign Anda mendorong mesin kami. Ini membantu kami mendesentralisasikan perdagangan dan membangun masa depan yang tahan sensor untuk semua kreator.`)
};

/** @type {(inputs: Support_DescriptionInputs) => LocalizedString} */
const ja_support_description = en_support_description;

/** @type {(inputs: Support_DescriptionInputs) => LocalizedString} */
const zh_support_description = en_support_description;

/** @type {(inputs: Support_DescriptionInputs) => LocalizedString} */
const ar_support_description = en_support_description;

/** @type {(inputs: Support_DescriptionInputs) => LocalizedString} */
const it_support_description = en_support_description;

/** @type {(inputs: Support_DescriptionInputs) => LocalizedString} */
const ru_support_description = en_support_description;

/** @type {(inputs: Support_DescriptionInputs) => LocalizedString} */
const pt_support_description = en_support_description;

/** @type {(inputs: Support_DescriptionInputs) => LocalizedString} */
const ko_support_description = en_support_description;

/**
* | output |
* | --- |
* | "Your sovereign contribution fuels our engine. It helps us decentralize commerce and build a censorship-resistant future for all creators." |
*
* @param {Support_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const support_description = /** @type {((inputs?: Support_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_DescriptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_support_description(inputs)
	if (locale === "es") return es_support_description(inputs)
	if (locale === "fr") return fr_support_description(inputs)
	if (locale === "de") return de_support_description(inputs)
	if (locale === "ja") return ja_support_description(inputs)
	if (locale === "zh") return zh_support_description(inputs)
	if (locale === "ar") return ar_support_description(inputs)
	if (locale === "id") return id_support_description(inputs)
	if (locale === "it") return it_support_description(inputs)
	if (locale === "ru") return ru_support_description(inputs)
	if (locale === "pt") return pt_support_description(inputs)
	return ko_support_description(inputs)
});